import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [provideEnvironmentInitializer(() => inject(AuthService))];
};
